export default __webpack_public_path__ + "static/media/katalk.479f083c.svg";